import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=4858dafa&scoped=true"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"
import style0 from "./policies.vue?vue&type=style&index=0&id=4858dafa&prod&scoped=true&lang=css"
import style1 from "./policies.vue?vue&type=style&index=1&id=4858dafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858dafa",
  null
  
)

export default component.exports